import { memo } from "react";

import { tw } from "classnames";

const styles = {
  container: tw(
    "flex",
    "gap-x-4",
    "border-0",
    "border-b",
    "border-solid",
    "border-divider",
    "bg-background-primary",
    "px-6",
    "py-4"
  ),
  image: tw("h-24", "w-24", "bg-placeholder"),
  detailsContainer: tw("flex", "flex-col"),
  line1: tw("mb-2", "h-4.5", "w-44", "animate-pulse", "bg-placeholder"),
  line2: tw("mb-2", "h-4.5", "w-36", "animate-pulse", "bg-placeholder"),
  line3: tw("mt-auto", "h-3.5", "w-7", "animate-pulse", "bg-placeholder"),
};

const CartItemPlaceholderBase = () => (
  <li className={styles.container}>
    <span className={styles.image}></span>
    <span className={styles.detailsContainer}>
      <span className={styles.line1}></span>
      <span className={styles.line2}></span>
      <span className={styles.line2}></span>
      <span className={styles.line3}></span>
    </span>
  </li>
);

export const CartItemPlaceholder = memo(CartItemPlaceholderBase);
